/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description List of Elements parents
 */
import { isValidId } from "./../utils/url-utils";
import useMeaQuery from "./useMeaQuery";
export interface MEAPathElement {
  id: string;
  name: string;
  typename: string;
  parentId: string;
  JS_ATTR?: string;
  symbol?: string;
}
type Hierarchy<T> = T & {
  children?: Hierarchy<T>[];
};
type MEAPathElementHierarchy = Hierarchy<MEAPathElement>;
const buildHierarchy = (arr: MEAPathElement[]): MEAPathElementHierarchy[] => {
  const mapMEAPathElements = (
    parent: MEAPathElementHierarchy
  ): MEAPathElementHierarchy => ({
    ...parent,
    children: arr
      .filter((child) => child.parentId === parent.id)
      .map(mapMEAPathElements),
  });
  return arr.filter((parent) => parent.parentId === "").map(mapMEAPathElements);
};
const flatten = (
  curry: MEAPathElement[],
  { children, ...rest }: MEAPathElementHierarchy
): MEAPathElement[] =>
  children && children?.length > 0
    ? children.reduce(flatten, [...curry, rest])
    : [...curry, rest];
const useParents = (meaid: string, throwError = true) => {
  const query = `[${meaid}].parentobjects(recursive=1, keeporiginals=1)`;
  const attributes =
    'name, typename, symbol, related(relation=parentObjects,as="parentId"), value(series="JS_ATTR", period="latestforseries" ,as="JS_ATTR")';
  const { data, error, isLoading } = useMeaQuery<MEAPathElement[]>(
    query,
    attributes,
    undefined,
    {
      keepPreviousData: false,
      enabled: !!meaid && isValidId(meaid),
    }
  );
  if (isLoading) return null;
  if (throwError && (!data || !data.data || !data.data.length || error)) {
    if (error) {
      throw new Error("Something went wrong!");
    }
  }
  const parentHierarchy = buildHierarchy(data?.data || []).reduce(flatten, []);
  return parentHierarchy;
};
export default useParents;
